/**
 * @param {object} state
 * @returns {{ label: string, id?: number }}
 */
export const getCurrentRegion = (state) => ({
  id: state.external?.regions?.currentRegion?.id || null,
  label: state.external?.regions?.currentRegion?.title || '',
});
